import React, { Component } from "react";
import { inject } from "mobx-react";
import ErrorContainer from '../portal/errorContainer';
import { Redirect } from 'react-router-dom';

@inject('oidcStore', 'authStore')
class CallbackContainer extends Component {

    state = {
        errorMessage: null
    };
    
    componentWillMount() {
        
        if (!this.props.oidcStore.currentUser) {
            
            let _this = this;
            this.props.oidcStore.completeLogin().then(function (user) {
                _this.props.authStore.getSessionTimeout().then(function(){
                    
                    window.location = user.state.originalUrl;
                })
                
            }).catch((e) => {
                console.error(e);
                this.setState({
                    errorMessage: e.message
                });
            });
        }
    }
    
    render() {
            
        if (this.props.oidcStore.currentUser != null) {          
            
                return <Redirect to='/' />;
        }
        else {
            return this.state.errorMessage ? 
                    <ErrorContainer error={ this.state.errorMessage }>
                    </ErrorContainer>
                    : 
                    null;
        }
    }
}

export default CallbackContainer;